import ImageComponent from 'components/Image';
import StarRating from 'components/StarRating';
import parse from 'date-fns/parse';
import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import format from 'utils/formatDate';
import RoundedAvatar from '~/reusable-components/avatars/RoundedAvatar';

const CSS = require('./HostReview.module.scss');

interface ExperienceReviewOuterProps {
  reviewer: {
    name: string;
    photoUrl: string;
  };
  date: string;
  rating: number;
  content: string;
  title: string;
}

const imageStyle = { width: 48, height: 48 };

function HostReview({
  reviewer,
  date,
  rating,
  content,
  title,
}: ExperienceReviewOuterProps) {
  const [isVisible, setVisible] = useState(false);
  const onWaypointEnter = (visible) => (visible ? setVisible(true) : null);

  const createdAt: Date = parse(date, "yyyy-MM-dd'T'HH:mm:ss", new Date());
  const reviewerNameClean = reviewer.name?.split('@')[0];

  return (
    <div data-test-id="HostReview" className={CSS.hostReview}>
      {!isVisible && (
        <VisibilitySensor
          delayedCall={true}
          intervalDelay={300}
          onChange={onWaypointEnter}
        />
      )}
      <div className={CSS.hostReviewHeader}>
        <div className={CSS.ImageContainer}>
          {isVisible && (
            <RoundedAvatar
              key={reviewer.photoUrl}
              image={reviewer.photoUrl}
              size={56}
              color="yellow"
            />
          )}
        </div>
        <div className={CSS.hostReviewDetails}>
          <div className={CSS.hostReviewName}>
            {reviewerNameClean || 'Unknown'}
          </div>
          <div className={CSS.hostReviewRating}>
            <StarRating rating={rating} />
          </div>
          <div className={CSS.hostReviewDate}>{format(createdAt, 'LL')}</div>
        </div>
      </div>
      <div className={CSS.hostReviewContent}>
        {content}
        <span className={CSS.ReviewTitle}>{title}</span>
      </div>
      <noscript>
        <ImageComponent options={imageStyle} src={reviewer.photoUrl} />
      </noscript>
    </div>
  );
}

export default HostReview;
